import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=2a56e8f6"
import script from "./payment-method.vue?vue&type=script&lang=js"
export * from "./payment-method.vue?vue&type=script&lang=js"
import style0 from "./payment-method.vue?vue&type=style&index=0&id=2a56e8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports